export default __webpack_public_path__ + "static/media/budget-prohibited.38a3e764.png";